<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>申请变卖清理单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_model_ctrl" :confKey="confKey" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :configAuto="true" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" v-if="checkActionPerm('create')" @click="createFiscalClearVoucher(false)">新增</button>
                <button class="swb-btn swb-btn-small" v-if="checkActionPerm('register')" @click="createFiscalClearVoucher(true)">
                    <span>登记</span>
                </button>
            </div>
        </div>
        <div name="tabs-block">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部" name="all"></el-tab-pane>
                <el-tab-pane name="applyInitial">
                    <span slot="label">未申请</span>
                </el-tab-pane>
                <el-tab-pane label="已申请" name="applyApplied"></el-tab-pane>
                <el-tab-pane name="applyHandled">
                    <span slot="label">已审核</span>
                </el-tab-pane>
            </el-tabs>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../app.conf'
    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { openAssetFiscalClearVoucherDetailDlg } from './showDlg'
    //
    import assetFiscalApi from '../../api/assetFiscal'
    import fiscalProofApi from '../../api/fiscalProof'
    import userApi from '../../api/user'
    //
    import SwbAssetFiscalClearVoucherSave from './AssetFiscalClearVoucherSave'
    import SwbShopDeviceRecList from '../retailer/ShopDeviceRecList'
    import SwbApplyDesc from '../bizUnion/ApplyDesc';
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    //
    Routes.add(SwbAssetFiscalClearVoucherSave);
    Vue.regist(SwbShopDeviceRecList);
    Vue.regist(SwbApplyDesc);
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    export default {
        name: 'swb-asset-fiscal-clear-voucher-list',
        path: '/asset/fiscal/clear/voucher/list/get',
        avlActions: 'create|view_detail|modify|apply|audit|delete|view_rec',
        avlScopes: 'retailer',
        desc: '资产未申请变卖清理单列表',
        data: function () {
            return {
                confKey: "swb-asset-fiscal-clear-voucher-list",
                tableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //排序、搜索
                queryKey: null,
                AuditPass: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                activeName: "all",
                no: null,
                initialCount: 0,
                appliedCount: 0,
                auditFailCount: 0,
                srcBizTypeMap: {},
                merchantId: null,
                ledgerStatePjenerating: getEnumInfoWith('ledgerState', 'name', 'Pjenerating').value, // 生凭中
                ledgerStatePjRecvDone: getEnumInfoWith('ledgerState', 'name', 'PjRecvDone').value, // 接受完毕，对方单据已返回
                ledgerStateNothing: getEnumInfoWith('ledgerState', 'name', 'Nothing').value, // 没有生凭
                ledgerStateMap: getEnumMap('ledgerState', 'value2text')
            }
        },
        created: function () {
            //
            let no = this.$route.query.no || null;
            if(!Utils.isNoB(no)) {
                this.queryModel.filterItems.no = no;
                this.no = no;
            }
            //
            this.srcBizTypeMap = getEnumMap("fiscalClearSrcType", "value2text");
            //
            let self = this;
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type == "info") {
                    self.merchantId = result.data.scopeEntity.id;
                } else {
                    self.$message.error(result.message);
                }
            });
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout,[name="query-sort-area"],.simple-row,[name="tabs-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let no = this.no;
                if(!Utils.isNoB(no)) {
                    let data = {value: no};
                    let fieldInfo = {};
                    fieldInfo["no"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
                //
                let fiscalClearSrcTypeList = getEnumList("fiscalClearSrcType");
                let dataList = [{"value": null, "label": "- 全部 -"}];
                if(fiscalClearSrcTypeList != null && fiscalClearSrcTypeList.length > 0) {
                    fiscalClearSrcTypeList.forEach(function (item) {
                        let dataInfo = {};
                        dataInfo.value = item.value;
                        dataInfo.label = item.text;
                        dataList.push(dataInfo);
                    });
                    query_model_ctrl.updateFields({
                        srcBizType: {
                            dataList: dataList
                        }
                    });
                }
                // 生凭状态
                dataList = [];
                dataList = [{"value": null, "label": "- 全部 -"}];
                let ledgerStateList = getEnumList("ledgerState");
                ledgerStateList.forEach(function (item) {
                    let ledgerState = {};
                    ledgerState.value = item.value;
                    ledgerState.label = item.text;
                    dataList.push(ledgerState);
                });
                this.updateQueryModelField("ledgerState", dataList);
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'auditState': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.applyState == 0) {
                            return '<span>未申请</span>';
                        } else if(row.applyState == 1) {
                            return '<span>已申请</span>';
                        } else if(row.applyState == 2) {
                            if(colValue === 1) {
                                return '<span class="font-green">审核已通过</span>';
                            } else if(colValue === -1) {
                                return '<span class="font-red">审核未通过</span>';
                            }
                        }
                    },
                    'deprMonth': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.deprMonth > 0) {
                            return '<span>' + row.deprMonth + '</span>';
                        }
                    },
                    'srcBizType': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.srcBizTypeMap[row.srcBizType] + '</span>';
                    },
                    // 生凭状态
                    'ledgerState': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.ledgerStateMap[row.ledgerState] + '</span>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if(self.checkActionPerm('apply', null, row.retailerBizUnitId) && row.applyState != 1 && row.auditState != 1) { //  && row.ledgerState == self.ledgerStatePjRecvDone
                            btnList.push({
                                name: 'apply',
                                text: '申请'
                            });
                        }
                        if(self.checkActionPerm('modify', null, row.retailerBizUnitId) && row.applyState != 1 && row.auditState != 1) { //  && row.ledgerState == self.ledgerStatePjRecvDone
                            btnList.push({
                                name: 'modify',
                                text: '修改'
                            });
                        }
                        if(self.checkActionPerm('delete', null, row.retailerBizUnitId) && ((row.auditState == -1 && row.applyState != 1) || row.applyState == 0)) {// && row.ledgerState == self.ledgerStateNothing
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            });
                        }
                        if(self.checkActionPerm('view_detail', null, row.retailerBizUnitId)) {
                            btnList.push({
                                name: 'view_detail',
                                text: '查看'
                            });
                        }
                        if(self.checkActionPerm('view_rec', null, row.retailerBizUnitId)) {
                            btnList.push({
                                name: 'view_rec',
                                text: '操作记录'
                            });
                        }
                        if(self.checkActionPerm('create_proof', null, row.retailerBizUnitId) && ((row.ledgerState > self.ledgerStatePjenerating && row.ledgerState < self.ledgerStatePjRecvDone) || (row.ledgerState == self.ledgerStatePjRecvDone && row.fiscalRevoked))) {
                            btnList.push({
                                name: 'create_proof',
                                text: '重新生凭'
                            });
                        }
                        if(self.checkActionPerm('proof_revoked', null, row.retailerBizUnitId) && row.ledgerState == self.ledgerStatePjRecvDone && !row.fiscalRevoked) {
                            btnList.push({
                                name: 'proof_revoked',
                                text: '凭证冲销'
                            });
                        }
//                        if(self.checkActionPerm('handle_confirm')) {
//                            btnList.push({
//                                name: 'handle_confirm',
//                                text: '手工确认'
//                            });
//                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                            return;
                        }
                        if(btnName == 'view_detail') {
                            self.viewFiscalClearVoucher(row.id);
                        } else if(btnName == 'modify') {
                            self.editorFiscalClearVoucher(row.id);
                        } else if(btnName == 'view_rec') {
                            self.showActRec(row.no);
                        } else if(btnName == 'apply') {
                            self.applyFiscalClearVoucher(row);
                        } else if(btnName == 'delete') {
                            self.doDeleteAssetFiscalClearVoucher(row.id);
                        } else if(btnName == 'create_proof') {
                            // 生凭、重新生凭
                            self.saveFiscalProof(row);
                        } else if(btnName == 'proof_revoked') {
                            // 凭证冲销
                            self.proofRevoked(row.id);
                        } else if(btnName == 'handle_confirm') {
                            // 手工确认
                            self.doHandleConfirm(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            checkActionPerm: function (action, targetPostId, dataOwnerComId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId, dataOwnerComId);
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //缓存查询条件
                this.getAssetFiscalClearVouchers();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getAssetFiscalClearVouchers();
            },

            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getAssetFiscalClearVouchers();
            },
            handleClick(){
                this.handlePageChange(1);
            },
            getAssetFiscalClearVouchers: function () {
                let self = this;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.tabCheckFlag = self.activeName;
                let state = filterItems.state;
                if(!Utils.isNoB(state)) {
                    if(state == 4) {
                        filterItems.applyState = 0;
                    } else if(state == 0) {
                        filterItems.applyState = 1;
                        filterItems.auditState = 0;
                    } else {
                        filterItems.auditState = state;
                    }
                }
                filterItems.retailerId = self.merchantId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                assetFiscalApi.getAssetFiscalClearVoucherList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.renderTable(result.data.rows, pagination);
//                        self.getApplyStateInitialTodoCount();
//                        self.getApplyStateAppliedTodoCount();
                        self.getAuditStateAuditFailTodoCount();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getApplyStateInitialTodoCount: function () {
                let self = this;
                assetFiscalApi.getAssetFiscalClearVoucherApplyStateInitialTodoCount({}, function (result) {
                    if(result.type == "info") {
                        self.initialCount = result.data;
                    }
                })
            },
            getApplyStateAppliedTodoCount: function () {
                let self = this;
                assetFiscalApi.getAssetFiscalClearVoucherApplyStateAppliedTodoCount({}, function (result) {
                    if(result.type == "info") {
                        self.appliedCount = result.data;
                    }
                })
            },
            getAuditStateAuditFailTodoCount: function () {
                let self = this;
                assetFiscalApi.getAssetFiscalClearVoucherAuditStateAuditFailTodoCount({}, function (result) {
                    if(result.type == "info") {
                        self.auditFailCount = result.data;
                    }
                })
            },
            createFiscalClearVoucher: function (autoApplyAndAudit) {
                if(!Utils.repeatChecker.isValidFor("createFiscalClearVoucher", 1000)) {
                    return;
                }
                this.$router.push({
                    path: SwbAssetFiscalClearVoucherSave.path,
                    query: {
                        autoApplyAndAudit: autoApplyAndAudit,
                        parentPath: this.$route.path
                    }
                });
            },
            // 报废单详情
            viewFiscalClearVoucher: function (id) {
                openAssetFiscalClearVoucherDetailDlg(id);
            },
            // 修改报废单
            editorFiscalClearVoucher: function (id) {
                this.$router.push({
                    path: SwbAssetFiscalClearVoucherSave.path,
                    query: {
                        id: id,
                        parentPath: this.$route.path
                    }
                });
            },
            // 申请报废单
            applyFiscalClearVoucher: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '清理单 - 申请',
                    showCloseBtn: true,
                    width: 600,
                    height: 400,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>申请描述</label>' +
                    '</div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-input type="textarea" v-model="applyDesc" :rows="3" placeholder="申请描述最大长度30个字" :maxlength="120"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>自动审核</label>' +
                    '</div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-checkbox v-model="autoAuditPass"></el-checkbox>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        applyDesc: null,
                        autoAuditPass: false
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let postData = {
                            id: row.id,
                            autoAuditPass: selfDlg.autoAuditPass,
                            applyDesc: selfDlg.applyDesc
                        };
                        let theLoad = MsgBox.loading();
                        assetFiscalApi.applyAssetFiscalClearVoucher(postData, function (result) {
                            theLoad.hide();
                            if(result.type === "info") {
                                MsgBox.success('申请成功!');
                                self.getAssetFiscalClearVouchers();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    },
                    lifecycle: {}
                });
            },
            // 删除报废单
            doDeleteAssetFiscalClearVoucher: function (id) {
                let self = this;
                self.$confirm('确定要删除该信息吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    assetFiscalApi.deleteAssetFiscalClearVoucher(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            self.getAssetFiscalClearVouchers();
                            MsgBox.success('删除成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 凭证冲销
            proofRevoked: function (bizVoucherId) {
                let self = this;
                this.$confirm('确定要进行凭证冲销吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        bizVoucherId: bizVoucherId,
                        sysBizTypeCode: getEnumInfoWith('sysBizType', 'name', 'ASSET_CLEAR').code
                    };
                    let theLoad = MsgBox.loading();
                    fiscalProofApi.updateFiscalBizProofForRevokedByBizVoucherId(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success("操作成功");
                            //
                            setTimeout(function () {
                                self.getAssetFiscalClearVouchers();
                            }, 500);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 重新生凭
            saveFiscalProof: function (row) {
                let self = this;
                this.$confirm('确定要重新生凭吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        bizVoucherId: row.id,
                        bizVoucherNo: row.no,
                        sysBizTypeCode: getEnumInfoWith('sysBizType', 'name', 'ASSET_CLEAR').code
                    };
                    let theLoading = MsgBox.loading();
                    fiscalProofApi.doRebuildCreateFiscalProofByBizVoucherId(postData, function (result) {
                        theLoading.close();
                        if(result.type == 'info') {
                            MsgBox.success("操作成功");
                            setTimeout(function () {
                                self.getAssetFiscalClearVouchers();
                            }, 500);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 手工确认
            doHandleConfirm: function (row) {
                let self = this;
                this.$confirm('确定要进行手工确认吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: row.id
                    };
                    //
                    let theLoading = MsgBox.loading();
                    assetFiscalApi.updateAssetFiscalClearVoucherLedgerState(postData, function (result) {
                        theLoading.close();
                        if(result.type == 'info') {
                            MsgBox.success("操作成功");
                            self.getAssetFiscalClearVouchers();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 清除单操作记录
            showActRec(no){
                Vue.$showDialog({
                    title: "清理单操作记录 - 查看",
                    width: 1200,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    okClicked: false,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-shop-device-act-rec-list :showComFlag="false" :srcVoucherNo="srcVoucherNo" :srcVoucherType="srcVoucherType" ref="swb_shop_device_act_rec_list"></swb-shop-device-act-rec-list>' +
                    '</div>',
                    data: {
                        srcVoucherNo: no,
                        srcVoucherType: getEnumInfoWith("devcVoucherType", "name", "FiscalOut").value
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/assetFiscal/AssetFiscalClearVoucherList.vue